import produce from "immer"
import { ASC } from "const"
import { MtStudyTeamMember } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initStudyTeamMember: MtStudyTeamMember = {
    id: null,
    studyId: null,
    name: "",
    company: "",
    title: "",
    department: "",
    competence: "",
    phone: "",
    email: "",
    comments: "",
}

const initStudyTeamMemberState: types.StudyTeamMemberState = {
    teamMemberList: {},
    teamMemberListByStudy: {},
    teamMemberIds: [],
    teamMemberView: initStudyTeamMember,
    teamMemberEdit: initStudyTeamMember,

    sortColumn: "id",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const studyTeamMemberReducer = produce((
    draft: types.StudyTeamMemberState = initStudyTeamMemberState,
    action: ActionTypes = null,
): types.StudyTeamMemberState => {
    switch (action.type) {
        case types.STUDY_TEAM_MEMBER_LIST:
            draft.teamMemberList = action.teamMemberList
            return draft

        case types.STUDY_TEAM_MEMBER_LIST_BY_STUDY:
            draft.teamMemberListByStudy = action.teamMemberListByStudy
            return draft

        case types.STUDY_TEAM_MEMBER_IDS:
            draft.teamMemberIds = action.teamMemberIds
            return draft

        case types.STUDY_TEAM_MEMBER_VIEW:
            draft.teamMemberView = action.teamMember
            return draft

        case types.STUDY_TEAM_MEMBER_EDIT:
            draft.teamMemberEdit = action.teamMember
            return draft

        case types.STUDY_TEAM_MEMBER_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.STUDY_TEAM_MEMBER_FILTERS:
            draft.filters = action.filters
            return draft

        case types.STUDY_TEAM_MEMBER_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.STUDY_TEAM_MEMBER_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default studyTeamMemberReducer
